
import store from '../config/store'

export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'info'
    },
    message: {
      type: String,
      required: true
    },
    wrapperClass: {
      type: String,
      required: false,
      default: ''
    },
    showApiMessages: {
      type: Boolean,
      required: false,
      default: true
    },
    button: {
      type: [Object, null],
      default: null
    }
  },

  data: () => ({
    store
  }),

  methods: {
    onClickButton () {
      this.$emit('buttonClicked')
    }
  }
}
